<template>
  <fragment>
    <div class="banner-shop-bottom" :style="myBlockProps.getStyles(visible)" @click="showModal">
      <div class="shop-banner-button">
        <div :style="textBtnStyle">{{ bannerShopTextTranslate }} ({{ getQtyTotalShop }})</div>
      </div>
    </div>
    <shop-cart-popup-block
      v-model="isShopModalVisible"
      @close="closeModal"
      :bannerShopCartTotalText="bannerShopCartTotalText"
      :bannerShopCartOrderBtnText="bannerShopCartOrderBtnText"
      :bannerShopCartCommentLabel="bannerShopCartCommentLabel"
      :bannerShopCartTextCommentBtnSave="bannerShopCartTextCommentBtnSave"
      :bannerShopTextProps="bannerShopTextProps"
      :bannerShopCartTitleModal="bannerShopCartTitleModal"
      :ordering="isOrdering"
      @onOrder="onOrder"
    />
    <info-popup-block
      :text="textForInfoPopUp"
      v-show="isInfoPopupVisible"
      @close="closeInfoPopup"
      :icon="iconInfoPopup"
      :color-icon="iconColorInfoPopup"
    />
  </fragment>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import axios from 'axios';
import Block from './Block.vue';
import { MultiLanguageText, TextProps, Order } from '../models';
import ShopCartPopupBlock from './ShopCartPopupBlock.vue';
import { MENU_ORDER_ENDPOINT } from '../constants/api';
import InfoPopupBlock from './InfoPopupBlock.vue';

export default {
  name: 'banner-shop-block',
  components: { ShopCartPopupBlock, InfoPopupBlock },
  extends: Block,
  props: {
    bannerShopText: { type: Object, required: true },
    bannerShopCartTotalText: { type: Object, required: true },
    bannerShopCartOrderBtnText: { type: Object, required: true },
    bannerShopTextProps: { type: Object, required: true, default: () => ({}) },
    bannerShopCartCommentLabel: { type: Object, required: true, default: () => ({}) },
    bannerShopCartTextCommentBtnSave: { type: Object, required: true, default: () => ({}) },
    bannerShopCartTitleModal: { type: Object, required: true, default: () => ({}) },
    bannerShopCartSuccessMessageOrder: { type: Object, required: true, default: () => ({}) },
    bannerShopCartErrorMessageOrder: { type: Object, required: true, default: () => ({}) },
  },
  data() {
    return {
      isVisible: true,
      bannerToggle: true,
      isShopModalVisible: false,
      isInfoPopupVisible: false,
      textForInfoPopUp: '',
      iconInfoPopup: '',
      iconColorInfoPopup: '',
      isOrdering: false
    };
  },
  computed: {
    ...mapGetters(['getProductPrice', 'selectedLanguage', 'getQtyTotalShop', 'getShopList', 'getTableGuid', 'subdomain']),
    myBannerShopText() {
      return new MultiLanguageText(this.bannerShopText);
    },
    myBannerShopCartSuccessMessageOrder() {
      return new MultiLanguageText(this.bannerShopCartSuccessMessageOrder);
    },
    myBannerShopCartErrorMessageOrder() {
      return new MultiLanguageText(this.bannerShopCartErrorMessageOrder);
    },
    myShopTextProps() {
      return new TextProps(this.bannerShopTextProps);
    },
    textBtnStyle() {
      return this.myShopTextProps.getStyles();
    },
    bannerShopTextTranslate() {
      return this.myBannerShopText.getText(this.selectedLanguage);
    },
    bannerShopCartSuccessMessageOrderTranslate() {
      return this.myBannerShopCartSuccessMessageOrder.getText(this.selectedLanguage);
    },
    bannerShopCartErrorMessageOrderTranslate() {
      return this.myBannerShopCartErrorMessageOrder.getText(this.selectedLanguage);
    },
  },
  methods: {
    ...mapActions(['resetShopList']),
    translate(item) {
      return (item !== undefined) ? item[this.selectedLanguage] : '';
    },
    closeInfoPopup() {
      this.isInfoPopupVisible = false;
    },
    closeModal() {
      this.isShopModalVisible = false;
    },
    showModal() {
      if (this.getQtyTotalShop > 0) {
        this.isShopModalVisible = true;
      }
    },
    async onOrder() {
      if (this.isOrdering) return;
      this.isOrdering = true;
      const order = new Order(this.getShopList, this.getTableGuid);
      const serializeData = order.serialize();
      try {
        const response = await axios.post(MENU_ORDER_ENDPOINT(this.subdomain), serializeData);
        if (response) {
          this.isInfoPopupVisible = true;
          this.textForInfoPopUp = this.bannerShopCartSuccessMessageOrderTranslate;
          this.iconInfoPopup = 'mdi-check-circle';
          this.iconColorInfoPopup = 'green';
          this.resetShopList();
        }
      } catch (e) {
        this.isInfoPopupVisible = true;
        this.textForInfoPopUp = this.bannerShopCartErrorMessageOrderTranslate;
        this.iconInfoPopup = 'mdi-alert-circle';
        this.iconColorInfoPopup = 'red';
      } finally {
        this.isOrdering = false;
        this.closeModal();
      }
    }
  }
};
</script>
<style>
.banner-shop-bottom {
  height: 40px;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 0;
  transition: all .5s;
  box-shadow: 0 -13px 15px -3px rgba(0, 0, 0, 0.1);
  cursor: pointer;
}

.shop-banner-button {
  padding: 10px 25px 25px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

</style>
